import * as z from "zod/v4";
import { IntegrationSchema } from "../types";

export const getAvailableIntegrations = {
  name: "getAvailableIntegrations" as const,
  input: z.object({}),
  output: z.object({ integrations: z.record(z.string(), IntegrationSchema) }),
};
